import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { API_URL, INVITE } from 'src/api';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';

export function useInviteSingleUserMutation(onSuccess: () => unknown) {
  const queryClient = useQueryClient();

  const { mutate: inviteSingleUser } = useMutation({
    mutationFn: (id: number) =>
      axios.post(`${API_URL}${INVITE}`, [{ user: id }]),
    onSuccess: () => {
      onSuccess();
      queryClient.invalidateQueries('SearchUsersPaginated');
      handleSuccessToast({ toastMessage: 'User Invited Successfully' });
    },
    onError: () => {
      handleErrorToast({ toastMessage: 'User invitation failed' });
    },
  });

  return inviteSingleUser;
}
